/**
  DO NOT EDIT THIS FILE MANUALLY
  Generated by `Opus::Mkt::Tools::GenerateReactData`
  If this file is out-of-sync or causing builds to fail, try running `scripts/bin/remote-script ./mkt/Tools/generate_react_data.rb`
*/

export const WorkEmailValidationRules = {
  validatedCountries: new Set([
    'US',
    'CA',
    'IN',
    'AE',
    'AT',
    'BE',
    'CH',
    'DE',
    'ES',
    'FR',
    'GB',
    'IE',
    'IT',
    'LU',
    'NL',
    'AF',
    'AO',
    'BG',
    'BH',
    'BJ',
    'CI',
    'CY',
    'CZ',
    'DK',
    'EE',
    'EG',
    'FI',
    'GH',
    'GI',
    'GL',
    'GM',
    'GR',
    'HR',
    'HU',
    'IL',
    'IQ',
    'IR',
    'IS',
    'JO',
    'KE',
    'KW',
    'KZ',
    'LB',
    'LI',
    'LT',
    'LV',
    'MA',
    'MC',
    'MT',
    'MU',
    'NA',
    'NE',
    'NO',
    'OM',
    'PL',
    'PT',
    'QA',
    'RO',
    'RS',
    'RU',
    'SA',
    'SE',
    'SI',
    'SK',
    'SN',
    'TN',
    'TR',
    'UA',
    'VA',
    'ZA',
    'AG',
    'AR',
    'BO',
    'BR',
    'BZ',
    'CL',
    'CO',
    'CR',
    'DO',
    'EC',
    'GT',
    'GY',
    'HN',
    'JM',
    'LC',
    'MX',
    'NI',
    'PA',
    'PE',
    'PY',
    'SV',
    'TT',
    'UY',
    'JP',
    'SG',
    'AU',
    'NZ',
  ]),
  disallowedDomains: new Set([
    '@163.com',
    '@abluec.com',
    '@aol.com',
    '@att.net',
    '@bellsouth',
    '@bigpond',
    '@btconnect',
    '@btinternet',
    '@charter.net',
    '@comcast',
    '@commongroundinternational',
    '@cox.net',
    '@e-cut',
    '@earthlink',
    '@eircom.',
    '@email.com',
    '@example.com',
    '@free.fr',
    '@gmail.com',
    '@gmx.com',
    '@gmx.de',
    '@googlemail.com',
    '@hotmail',
    '@icloud.com',
    '@iinet.net.au',
    '@juno.com',
    '@laposte.net',
    '@libero.it',
    '@live.ca',
    '@live.co',
    '@mac.com',
    '@mail.com',
    '@mail.ru',
    '@me.com',
    '@msn.com',
    '@myfairpoint',
    '@na.com',
    '@none.com',
    '@optonline',
    '@optusnet',
    '@orange.fr',
    '@outlook',
    '@pac-print',
    '@protonmail',
    '@psychz',
    '@qq.com',
    '@rocketmail',
    '@rogers.com',
    '@sasktel',
    '@sbcglobal',
    '@sfr.fr',
    '@shaw.ca',
    '@shopify',
    '@sky.com',
    '@superchargedsystems',
    '@swimtails.com',
    '@tbd.com',
    '@telus.net',
    '@telusplanet',
    '@test.com',
    '@verizon',
    '@ves.edu',
    '@vianet.ca',
    '@wanadoo',
    '@xtra.co.nz',
    '@yahoo',
    '@yandex',
    '@ymail.com',
  ]),
} as const;
